const NAMESPACE = "incentiveDesignsTab";

const KEYS = {
    newIncentiveDesignButtonText: "newIncentiveDesignButtonText",
    emptyIncentiveDesignTableText: "emptyIncentiveDesignTableText",
    nameColumnHeader: "nameColumnHeader",
    typeColumnHeader: "typeColumnHeader",
    startDateColumnHeader: "startDateColumnHeader",
    expirationDateColumnHeader: "expirationDateColumnHeader",
    conditionsColumnHeader: "conditionsColumnHeader",
    approvedAmountCapHeader: "approvedAmountCapHeader",
    statusColumnHeader: "statusColumnHeader",
    editableColumnHeader: "editableColumnHeader",
    incentiveTypeOneTimeText: "incentiveTypeOneTimeText",
    incentiveTypePBIText: "incentiveTypePBIText",
    incentiveTypeFormulaText: "incentiveTypeFormulaText",
    incentiveTypeFlatText: "incentiveTypeFlatText",
    incentiveTypeCGBOneRatePBIText: "incentiveTypeCGBOneRatePBIText",
    incentiveTypeCGBTieredPBIText: "incentiveTypeCGBTieredPBIText",
    incentiveTypeCGBTieredEPBBText: "incentiveTypeCGBTieredEPBBText",
    editButtonText: "editButtonText",
    viewButtonText: "viewButtonText",
    copyButtonText: "copyButtonText",
    disabledStatusText: "disabledStatusText",
    enabledStatusText: "enabledStatusText",
    futureStatusText: "futureStatusText",
    expiredStatusText: "expiredStatusText",
    yesText: "yesText",
    noText: "noText",
    cpadminText: "cpadminText",
    setExpDateButtonText: "setExpDateButtonText",
    enableButtonText: "enableButtonText",
    disableButtonText: "disableButtonText",
    deleteButtonText: "deleteButtonText"
};

const MESSAGES = {
    [KEYS.newIncentiveDesignButtonText]: {
        value: "New Incentive Design",
        comment: "Text for the New Incentive Design button"
    },
    [KEYS.emptyIncentiveDesignTableText]: {
        value: "No incentive designs defined.",
        comment: "Text for the empty Incentive Design table"
    },
    [KEYS.approvalStatusHeader]: {
        value: "Approval Status",
        comment: "Header for the Approval Status panel"
    },
    [KEYS.nameColumnHeader]: {
        value: "Name",
        comment: "Incentive Design Name column header"
    },
    [KEYS.typeColumnHeader]: {
        value: "Type",
        comment: "Incentive Design Type column header"
    },
    [KEYS.startDateColumnHeader]: {
        value: "Start Date",
        comment: "Incentive Design Start Date column header"
    },
    [KEYS.expirationDateColumnHeader]: {
        value: "Expiration Date",
        comment: "Incentive Design Expiration Date column header"
    },
    [KEYS.conditionsColumnHeader]: {
        value: "Conditions",
        comment: "Incentive Design Eligibility Conditions column header"
    },
    [KEYS.approvedAmountCapHeader]: {
        value: "Cap by Approved Amount",
        comment: "Cap Incentive Design by Approved Amount column header"
    },
    [KEYS.statusColumnHeader]: {
        value: "Status",
        comment: "Incentive Design Status column header"
    },
    [KEYS.editableColumnHeader]: {
        value: "Editable",
        comment: "Incentive Design Editable column header"
    },
    [KEYS.incentiveTypeOneTimeText]: {
        value: "One-Time",
        comment: "Text displayed for a One-Time incentive"
    },
    [KEYS.incentiveTypePBIText]: {
        value: "PBI",
        comment: "Text displayed for a PBI incentive"
    },
    [KEYS.incentiveTypeFormulaText]: {
        value: "Formula",
        comment: "Text displayed for a Formula incentive"
    },
    [KEYS.incentiveTypeFlatText]: {
        value: "Flat",
        comment: "Text displayed for a Flat incentive"
    },
    [KEYS.incentiveTypeCGBOneRatePBIText]: {
        value: "One-Rate PBI",
        comment: "Text displayed for a CGB One-Rate PBI incentive"
    },
    [KEYS.incentiveTypeCGBTieredPBIText]: {
        value: "Tiered PBI",
        comment: "Text displayed for a CGB Tiered PBI incentive"
    },
    [KEYS.incentiveTypeCGBTieredEPBBText]: {
        value: "Tiered EPBB",
        comment: "Text displayed for a CGB Tiered EPBB incentive"
    },
    [KEYS.editButtonText]: {
        value: "Edit Design",
        comment: "Text for the Edit Design button"
    },
    [KEYS.viewButtonText]: {
        value: "View Design",
        comment: "Text for the View Design button"
    },
    [KEYS.copyButtonText]: {
        value: "Copy Design",
        comment: "Text for the Copy Design button"
    },
    [KEYS.disabledStatusText]: {
        value: "Disabled",
        comment: "Text describing the status of an incentive design which is not enabled"
    },
    [KEYS.enabledStatusText]: {
        value: "Active",
        comment:
            "Text describing the status of an incentive design which is enabled and between its Start and Expiration Dates (if any)"
    },
    [KEYS.futureStatusText]: {
        value: "Future",
        comment:
            "Text describing the status of an incentive design which is enabled but its Start Date is in the future"
    },
    [KEYS.expiredStatusText]: {
        value: "Expired",
        comment:
            "Text describing the status of an incentive design which is enabled but its Expiration Date is in the past"
    },
    [KEYS.yesText]: {
        value: "Yes",
        comment: "Text used to display a Yes value"
    },
    [KEYS.noText]: {
        value: "No",
        comment: "Text used to display a No value"
    },
    [KEYS.cpadminText]: {
        value: "CPAdmin",
        comment: "Text used to indicate a 'CP Admin' value"
    },
    [KEYS.setExpDateButtonText]: {
        value: "Set Expiration Date",
        comment: "Text for the Set Expiration Date button"
    },
    [KEYS.enableButtonText]: {
        value: "Enable",
        comment: "Text for the Enable button"
    },
    [KEYS.disableButtonText]: {
        value: "Disable",
        comment: "Text for the Disable button"
    },
    [KEYS.deleteButtonText]: {
        value: "Delete Design",
        comment: "Text for the Delete button"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
